export default __webpack_public_path__ + "static/media/4248.91a171f8.png";